module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    },
    on: {
      "close": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "do-modal do-modal__reasons-form",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n.create_absence))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [(_vm.isAbsenceIntegrationActive && _vm.isSalarySystemKMD) ? _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label marg-025-bottom"
  }, [_vm._v("Vælg fraværsårsag fra OPUS")]), _vm._v(" "), _c('DSelect', {
    key: 'absenceCode-' + _vm.resetDSelectCounter,
    ref: "absenceCodeSelect",
    attrs: {
      "items": _vm.absenceCodesForDSelect,
      "multiple": false,
      "placeholder": 'Vælg kode fra OPUS',
      "itemsSelected": _vm.selectedAbsenceCodeForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectAbsenceCode,
      "remove": function($event) {
        return _vm.onSelectAbsenceCode(null)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAbsenceIntegrationActive && _vm.isSalarySystemSD) ? _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label marg-025-bottom"
  }, [_vm._v("Vælg fraværsårsag fra SD")]), _vm._v(" "), _c('DSelect', {
    key: 'sdAbsenceCode-' + _vm.resetDSelectCounter,
    ref: "sdAbsenceCodeSelect",
    attrs: {
      "items": _vm.sdAbsenceCodesForDSelect,
      "multiple": false,
      "placeholder": 'Vælg kode fra SD',
      "itemsSelected": _vm.selectedSdAbsenceCodeForDSelect,
      "isShowRemoveButton": false
    },
    on: {
      "add": _vm.onSelectSdAbsenceCode,
      "remove": function($event) {
        return _vm.onSelectSdAbsenceCode(null)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-group marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n.title))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newReasonTitle),
      expression: "newReasonTitle"
    }],
    staticClass: "d-input",
    class: {
      'd-input--error': _vm.errors.newReasonTitle
    },
    domProps: {
      "value": (_vm.newReasonTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onCreate.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newReasonTitle = $event.target.value
      }, _vm.clearErrors]
    }
  }), _vm._v(" "), (_vm.errors.newReasonTitle) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.errors.newReasonTitle))]) : _vm._e()]), _vm._v(" "), (_vm.shouldShowDefaultOngoing) ? _c('div', {
    staticClass: "d-label-and-toggle marg-1-top",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.defaultOngoing = !_vm.defaultOngoing
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n.default_ongoing))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.defaultOngoing,
      "allowChanges": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle marg-1-top",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.canRequest = !_vm.canRequest
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n.can_be_requested))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.canRequest,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-label-and-toggle marg-1-top",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.defaultPrivate = !_vm.defaultPrivate
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n.hide_title))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.defaultPrivate,
      "allowChanges": false
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "marg-1-top italic"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.i18n.default_private_explained)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isCreating
    },
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-599cef24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AbsenceReasons/AbsenceReasonsCreate.vue
// module id = 1940
// module chunks = 1